import { combineEpics, ofType, StateObservable } from 'redux-observable';
import { of } from 'rxjs';
import { distinctUntilChanged, filter, map, mergeMap, pairwise } from 'rxjs/operators';

import { getGeneralInfoContent } from 'actions/other';
import { getSettingsFallbackResp } from 'actions/settings';
import {
  getAssetList,
  getOptionsInfo,
  getSpotIndices,
  getStats,
  getTradePreferences,
  getWithdrawalTradingCredits,
} from 'actions/trade';
import { getAppliedPromos, getOffers, getReferralData } from 'actions/user';
import SETTINGS from 'actionTypes/settings';
import IState, { CustomAction } from 'types/Istore';

const settingsFallbackEpic = (action$: CustomAction) =>
  action$.pipe(
    ofType(SETTINGS.GET_SETTINGS.FAIL),
    map(() => getSettingsFallbackResp())
  );

// Epic to handle transition from degraded mode to live mode
const degradedModeRecoveryEpic = (
  action$: CustomAction,
  state$: StateObservable<IState>
) =>
  state$.pipe(
    map(state => state.settings.app_status),
    distinctUntilChanged(), // Only emit when app_status actually changes
    pairwise(), // Get [previousValue, currentValue]
    filter(([prevStatus, currentStatus]) => {
      // Only trigger when transitioning from degraded_mode to live
      return prevStatus === 'degraded_mode' && currentStatus === 'live';
    }),
    mergeMap(() => {
      // Dispatch all the API calls that were skipped during degraded mode boot
      return of(
        getAssetList(),
        getSpotIndices(),
        getGeneralInfoContent(),
        getOptionsInfo(),
        getStats(),
        getOffers(),
        getAppliedPromos(),
        getWithdrawalTradingCredits(),
        getTradePreferences(),
        getReferralData()
      );
    })
  );

export default combineEpics(settingsFallbackEpic, degradedModeRecoveryEpic);
